<template>
  <div class="job">
    <!-- Valid job object -->
    <template v-if="job">
      <div class="job-header">
        <div>
          <h2>{{ job.title }}</h2>
          <h3>{{ job.location }}</h3>
        </div>
        <div>
          <img
            :src="`https://logo.clearbit.com/${job.company.url}`"
            :alt="job.company.company"
          />
          <!-- <pre>{{ job.company.logo }}</pre> -->
          <!-- <h2>{{ job.company.company }}</h2> -->
        </div>
      </div>

      <!-- <div>{{ job.raw.content }}</div> -->

      <div class="description">
        <a
          :href="job.url"
          class="button"
          target="_blank"
          style="margin-left: 2rem; margin-bottom: 1rem;float:right;"
          >Apply</a
        >
        <div v-html="job.description" />
      </div>
    </template>

    <!-- No job selected -->
    <template v-else>
      <div class="job-header">
        <div>
          <h2>Job Title</h2>
          <h3>Location</h3>
        </div>
        <div>
          <img
            src="https://logo.clearbit.com/heavybit.com"
            style="opacity: 20%; border-radius:10px;"
          />
        </div>
      </div>
      <div class="description">
        Select a job from the list for more details.
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "Job",
  props: {
    job: { type: Object, required: false, default: () => {} },
  },
};
</script>

<style>
.job {
  flex: 1;
  min-height: 39rem;
}
.job-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.job-header > *:last-child {
  text-align: right;
}

.job-header > *:last-child h2 {
  margin-bottom: 0.7rem;
}

.job-header img {
  margin-top: 1rem;
  display: block;
  max-width: 65px;
  /* border-radius: 10px; */
}

.button {
  padding: 0.3rem 1rem;
  border: 1px sold darkblue;
  border-radius: 3px;
  background: cornflowerblue;
  color: white;
  text-decoration: none;
  cursor: pointer;
  display: inline-block;
}
.button:hover {
  background: blue;
}

.description * {
  font-size: small;
  line-height: 1.3rem;
  list-style-type: disc;
}

.description li p {
  padding: 0 !important;
  margin: 0 !important;
}

.description p,
.description span,
.description li {
  font-weight: unset !important;
}
.description h1,
.description h2,
.description h3,
.description h4,
.description b,
.description strong {
  font-weight: 500;
}
.description p,
.description div {
  margin-block-start: 1em;
  margin-block-end: 1em;
}
.description ul > ul {
  padding-left: 0;
}

.description .content-intro {
  margin-bottom: 0;
}

.description u {
  text-decoration: none;
}

hr {
  border: 0;
  height: 1px;
  border-bottom: 1px solid lightgray;
}
</style>
